import { API_BASE_URL } from '../../config'
import {
  SWIPE_REQUEST,
  SWIPE_SUCCESS,
  SWIPE_FAILURE,
  UNDO_SWIPE_REQUEST,
  UNDO_SWIPE_SUCCESS,
  UNDO_SWIPE_FAILURE
} from './swipeActionTypes'

export const swipePost = (postId, direction) => async (dispatch) => {
  dispatch({ type: SWIPE_REQUEST })

  try {
    const token = localStorage.getItem('auth_token')
    if (!token) {
      throw new Error('No authentication token found')
    }

    const response = await fetch(`${API_BASE_URL}/swipes/`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
        'X-CSRFTOKEN': document.cookie.split('csrftoken=')[1]?.split(';')[0] || ''
      },
      credentials: 'include',
      body: JSON.stringify({
        post: postId,
        direction: direction
      })
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'Failed to process swipe')
    }

    const data = await response.json()
    dispatch({
      type: SWIPE_SUCCESS,
      payload: data
    })
    return data
  } catch (error) {
    dispatch({
      type: SWIPE_FAILURE,
      payload: error.message
    })
    throw error
  }
}

// Deletes the user's most recent swipe, restoring that post to the deck
// (mirrors the "rewind" feature in Tinder/Bumble).
export const undoSwipe = () => async (dispatch) => {
  dispatch({ type: UNDO_SWIPE_REQUEST })

  try {
    const token = localStorage.getItem('auth_token')
    if (!token) {
      throw new Error('No authentication token found')
    }

    const response = await fetch(`${API_BASE_URL}/swipes/undo/`, {
      method: 'DELETE',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
        'X-CSRFTOKEN': document.cookie.split('csrftoken=')[1]?.split(';')[0] || ''
      },
      credentials: 'include'
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Failed to undo swipe')
    }

    dispatch({
      type: UNDO_SWIPE_SUCCESS,
      payload: data
    })
    return data
  } catch (error) {
    dispatch({
      type: UNDO_SWIPE_FAILURE,
      payload: error.message
    })
    throw error
  }
}
